<template>
  <div v-if="visible" class="cookie-overlay">
    <div class="cookie-modal">
      <h3>{{ $t('cookies.cookies.title') }}</h3>
      <p>{{ $t('cookies.cookies.description') }}</p>

      <div class="buttons">
        <button class="accept" @click="acceptAll">
          {{ $t('cookies.cookies.accept') }}
        </button>
        <button class="reject" @click="rejectAll">
          {{ $t('cookies.cookies.reject') }}
        </button>
      </div>

      <a href="/privacy" class="link">
        {{ $t('cookies.cookies.privacy_policy') }}
      </a>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'

const visible = ref(false)

onMounted(() => {
  const consent = localStorage.getItem('cookieConsent')
  if (!consent) visible.value = true
})

const acceptAll = () => {
  localStorage.setItem(
    'cookieConsent',
    JSON.stringify({ accepted: true, date: new Date().toISOString() })
  )
  visible.value = false
}

const rejectAll = () => {
  localStorage.setItem(
    'cookieConsent',
    JSON.stringify({ accepted: false, date: new Date().toISOString() })
  )
  visible.value = false
}
</script>

<style scoped>
.cookie-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: none;
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease forwards;
}

.cookie-modal {
  background: rgba(255, 255, 255, 0.9); /* ← чуть прозрачное */
  backdrop-filter: blur(6px);            /* ← размытие заднего фона */
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  padding: 30px 25px;
  max-width: 420px;
  width: 90%;
  text-align: center;
  color: #333;
  animation: slideUp 0.4s ease;
}


.cookie-modal h3 {
  margin-bottom: 10px;
  font-size: 18px;
  font-weight: 600;
  color: #111;
}

.cookie-modal p {
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 20px;
  color: #555;
}

.cookie-modal .buttons {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-bottom: 10px;
}

.cookie-modal button {
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.25s ease;
}

.cookie-modal button.accept {
  background-color: #007bff;
  color: white;
  border: none;
}

.cookie-modal button.accept:hover {
  background-color: #0056b3;
}

.cookie-modal button.reject {
  background-color: #f1f1f1;
  color: #333;
  border: 1px solid #ccc;
}

.cookie-modal button.reject:hover {
  background-color: #e1e1e1;
}

.cookie-modal .link {
  display: inline-block;
  margin-top: 10px;
  font-size: 13px;
  color: #007bff;
  text-decoration: underline;
}

.cookie-modal .link:hover {
  color: #0056b3;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideUp {
  from { opacity: 0; transform: translateY(30px); }
  to { opacity: 1; transform: translateY(0); }
}
</style>
